"use client";

import { ConfigModelSelect } from "../ConfigModelSelect";
import { ConfigOption } from "../ConfigOption";
import { ConfigSidebarLayout } from "./ConfigSidebarLayout";
import { useConfigSidebar } from "./useConfigSidebar";
import { EndpointType } from "../../../constants/Endpoints";
import { DEFAULT_OCR_INFERENCE_CONFIG } from "../../../constants/OcrInferenceConfig";
import { OcrModeType } from "../../../types/dpInferenceConfig";
import {
  OcrInferenceConfig,
  OcrInferenceConfigField,
  OcrModelType,
} from "../../../types/ocrInferenceConfig";
import { configStore } from "../../../utils/mobx/ConfigStore";

export default function OcrConfigSidebar({
  isOpen,
  onClose,
  className,
  endpointType,
}: {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  endpointType: EndpointType;
}) {
  const {
    config,
    setConfig,
    isOverflowing,
    contentRef,
    isMobile,
    inferenceState,
    accessibleModels,
    handleReset,
    handleApply,
  } = useConfigSidebar<OcrInferenceConfig>({
    endpointType,
    onClose,
    getCurrentConfig: () => configStore.currentOcrConfig,
    defaultConfig: DEFAULT_OCR_INFERENCE_CONFIG,
    resetStoreConfig: () => configStore.resetOcrConfig(),
    getResetConfig: () => configStore.currentOcrConfig,
  });

  // 설정 변경
  const handleChange = (
    field: OcrInferenceConfigField,
    value: OcrModeType | OcrModelType,
  ) => {
    if (field === "model") {
      const newModel = value as OcrModelType;
      const nextConfig: OcrInferenceConfig = {
        ...config,
        model: newModel,
      };

      setConfig(nextConfig);
      configStore.setOcrConfig(nextConfig);
      return;
    }

    const newConfig: OcrInferenceConfig = {
      ...(config as OcrInferenceConfig),
      [field]: value,
    } as OcrInferenceConfig;

    setConfig(newConfig);
    configStore.setOcrConfig(newConfig);
  };

  return (
    <ConfigSidebarLayout
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      isMobile={isMobile}
      isOverflowing={isOverflowing}
      contentRef={contentRef}
      onReset={handleReset}
      onApply={handleApply}
      disabled={inferenceState.isInfering}
    >
      <ConfigOption label="Model" orientation="vertical">
        <ConfigModelSelect
          value={config.model}
          onValueChange={value => handleChange("model", value as OcrModelType)}
          disabled={inferenceState.isInfering}
          accessibleModels={accessibleModels}
        />
      </ConfigOption>
    </ConfigSidebarLayout>
  );
}
